import type { QpsQuestionModel, QpsQuestionnaire, QpsScore, QpsUserAnswers } from '@/types/qps';

// Used for the immediate right/wrong feedback after each question.
const isQpsAnswerCorrect = (question: QpsQuestionModel, selectedValue: string | undefined): boolean =>
  question.answers.some((answer) => answer.value === selectedValue && answer.isCorrect);

/**
 * Spirica rule: 1 point per right answer, the questionnaire is passed only
 * when the score equals the number of questions (all answers right).
 */
const computeQpsScore = (questionnaire: QpsQuestionnaire, userAnswers: QpsUserAnswers): QpsScore => {
  const total = questionnaire.questions.length;
  const score = questionnaire.questions.filter((question) =>
    isQpsAnswerCorrect(question, userAnswers[question.id])
  ).length;

  return {
    score,
    total,
    isPassed: total > 0 && score === total,
  };
};

export { computeQpsScore, isQpsAnswerCorrect };
